import { Component } from '@angular/core';
import {
  StorageKey,
  StorageService,
} from '../../services/common/storage.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from '../../services/common/common.service';
import { ApiService } from '../../services/api.service';
import { ApiUrlHelper } from '../../services/api-url-helper/api-url-helper';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../services/languageService/language-service.service';
import { CookieService } from '../../services/cookieService/cookie.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent {
  loginForm: FormGroup;
  passwordinputType = 'password';
  isPartnerFlow = false;
  constructor(
    private storageService: StorageService,
    private formBuilder: FormBuilder,
    private router: Router,
    private commonService: CommonService,
    private apiService: ApiService,
    private apiUrl: ApiUrlHelper,
    private toaster: ToastrService,
    private spinner: NgxSpinnerService,
    private route: ActivatedRoute,
    private languageService: LanguageService,
    private translate: TranslateService,
    private cookieService: CookieService,
    private dataService: StorageService,
  ) {
    this.loginForm = this.formBuilder.group({
      Email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required]],
    });
  }
  ngOnInit(): void {
    this.languageService.language$.subscribe((language) => {
      this.translate.use(language);
    });
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.

    // const lang = this.cookieService.get('language');
    // this.translate.use(lang || 'eng');
    this.storageService.clearAll();
    this.cookieService.clearAllCookies();
    this.dataService.setLeadId("0");

    const userType = this.route.snapshot.queryParamMap.get('userType');
    if (userType === '5') {
      this.isPartnerFlow = true;
    }
  }
  onLogin() {
    Object.keys(this.loginForm.controls).forEach((key) => {
      const control = this.loginForm.get(key);
      if (control && typeof control.value === 'string') {
        control.setValue(control.value.trim(), { emitEvent: false });
      }
    });

    if (this.loginForm.valid) {
      const FormData = {
        Email: this.loginForm.controls['Email'].value.trim(),
        password: this.loginForm.controls['password'].value.trim(),
      };

      this.spinner.show();
      const apiUrl = this.apiUrl.apiUrl.User.login;
      this.apiService
        .doPost(apiUrl, FormData)
        .pipe()
        .subscribe({
          next: (response) => {
            this.spinner.hide();
            if (response && response.Success) {
              this.toaster.success(
                this.translate.instant('LOGIN_SUCCESS_MESSAGE')
              );
              this.storageService.clearAll();
              this.storageService.setValue(
                StorageKey.authToken,
                response.Data.Token
              );
              this.saveLanguage();
              if (
                response.Data.IsRegistrationCompleted == true &&
                response.Data.UserTypeId == 1
              ) {
                this.router.navigate(['/admin/dashboard']); //admin dashboard
              } else if (
                response.Data.IsRegistrationCompleted == false &&
                response.Data.UserTypeId == 2
              ) {
                // customer
                this.router.navigate(['/register']); //Customer registration
              } else if (
                response.Data.IsRegistrationCompleted == true &&
                response.Data.UserTypeId == 2
              ) {
                // customer resgitsration
                this.router.navigate(['/homepage']); //Customer dashboard
              } else if (
                response.Data.IsRegistrationCompleted == true &&
                response.Data.UserTypeId == 3
              ) {
                this.router.navigate(['/dashboard']); //firm dashboard
              } else if (
                response.Data.IsRegistrationCompleted == false &&
                response.Data.UserTypeId == 3
              ) {
                this.router.navigate(['/firm-registration']); //firm registration
              } else if (
                response.Data.IsRegistrationCompleted == false &&
                response.Data.UserTypeId == 4
              ) {
                this.storageService.setValue(
                  'IsRegistrationCompleted',
                  response.Data.IsRegistrationCompleted.toString()
                );
                const agentId =
                  this.storageService.getTokenData()?.AgentId.toString() ?? '';
                let urlparam = encodeURIComponent(
                  btoa(this.commonService.Encrypt(agentId))
                );
                this.router.navigate(['/agent-profile', urlparam]); //Agent registration
              } else if (
                response.Data.IsRegistrationCompleted == true &&
                response.Data.UserTypeId == 4
              ) {
                this.router.navigate(['/agent-dashboard']); //Agent  dashboard
              } else if (
                response.Data.IsRegistrationCompleted == false &&
                response.Data.UserTypeId == 5
              ) {
                this.router.navigate(['/partner/registration']); // Partner registration
              } else if (
                response.Data.IsRegistrationCompleted == true &&
                response.Data.UserTypeId == 5
              ) {
                this.router.navigate(['/partner/dashboard']); // Partner dashboard
              }
            } else {
              this.toaster.error(this.translate.instant(response.Message));
            }
          },
          error: (er) => {
            this.spinner.hide();
            this.toaster.error(er.Message);
          },
        });
    }
  }
  changeInputType(input_type: any, fieldName: any) {
    if (fieldName == 'password') {
      if (input_type == 'password') {
        this.passwordinputType = 'text';
      } else {
        this.passwordinputType = 'password';
      }
    }
  }
  forgotPassword() {
    const userType = this.route.snapshot.queryParamMap.get('userType');
    if (userType) {
      this.router.navigate(['/forgotPassword'], { queryParams: { userType }, replaceUrl: true });
    } else {
      const currentUrl = this.router.url;
      const newUrl = currentUrl.replace('login', 'forgotPassword');
      this.router.navigateByUrl(newUrl, { replaceUrl: true });
    }
  }

  refreshPage() {
    window.location.reload();
  }

  noSpaceAllowed(event: any) {
    const input = event.target as HTMLInputElement;
    if (event.key === ' ') {
      // Remove all spaces from the input
      input.value = input.value.replace(/\s/g, '');
    }
  }

  saveLanguage() {
    const selectedLang = this.languageService.getLoginLanguage();

    if (selectedLang == '' || selectedLang == undefined || selectedLang == null) {
      this.getPreferLanguage();
    } else {
      let apiUrl = this.apiUrl.apiUrl.account.savePreferLanguage;
      let email = this.storageService.getTokenData()?.Email;
      let objdata = {
        Email: email,
        PreferLanguage: selectedLang,
      };

      this.apiService.doPost(apiUrl, objdata).subscribe({
        next: (data) => {
          if (data && data.Success) {
            // this.toaster.success(this.translate.instant(data.Message));
          }
        },
        error: (err) => {
          this.toaster.error(err);
        },
      });
    }
  }

  getPreferLanguage() {
    let email = this.storageService.getTokenData()?.Email;
    let apiUrl =
      this.apiUrl.apiUrl.account.getPreferLanguage + `?Email=${email}`;
    this.apiService.doGet(apiUrl).subscribe({
      next: (data) => {
        if (data && data.Success) {
          this.languageService.setLanguage(data.Data.PreferLanguage);
        }
      },
      error: (err) => {
        this.toaster.error(err);
      },
    });
  }
}
